import { Group } from "antd/lib/avatar";
import { Divider, Title } from "components/common";
import ImageVideoSlider from "components/common/imageVideoSlider/imageVideoSlider";
import styles from "./index.module.less";

const ScriptPodcastSection = ({ details }) => {
  return details?.podCast?.length ? (
    <div id={"Podcasts"} className={styles.schemaSection}>
      <div className={styles.schemaHeader}>
        <div className={styles.schemaTitle}>
          <span>Podcasts</span>
        </div>
        <div className={styles.schemaCount}>
          {details.podCast.length}{" "}
          {details.podCast.length === 1 ? "Podcast" : "Podcasts"}
        </div>
      </div>
      <ImageVideoSlider
        dataList={details?.podCast?.map((e) => ({
          ...e,
          url: e?.ImageURL,
        }))}
        width={"25%"}
        height={200}
        showNavigation={true}
        showPagination={false}
      />
      <Divider />
    </div>
  ) : null;
};

export default ScriptPodcastSection;
